import { createAction } from '@reduxjs/toolkit';

export const promoBarUpdateId = createAction('promoBar/updateId');
export const promoBarUpdateIsAdded = createAction('promoBar/updateIsAdded');
export const promoBarUpdateIsActive = createAction('promoBar/updateIsActive');

export const promoBarStore = createAction('promoBar/store');
export const promoBarClear = createAction('promoBar/clear');

export const promoBarUpdateRequest = createAction('promoBar/updateRequest');
export const promoBarUpdateError = createAction('promoBar/updateRrror');
export const promoBarUpdateStore = createAction('promoBar/updateStore');

export const promoBarUpdateMessage = createAction('promoBar/updateMessage');
export const promoBarUpdateColor = createAction('promoBar/updateColor');
export const promoBarUpdateOpacity = createAction('promoBar/updateOpacity');
export const promoBarUpdateTextSize = createAction('promoBar/updateTextSize');
export const promoBarIsMaster = createAction('promoBar/isMasterPromobar');
export const promoBarUpdateAnimation = createAction('promoBar/updateAnimation');
export const promoBarUpdateActionType = createAction('promoBar/updateActionType');

export const promoBarUpdateCTASite = createAction('promoBar/updateCTASite');
export const promoBarUpdateCTASiteText = createAction('promoBar/updateCTASiteText');
export const promoBarUpdateCTALinkId = createAction('promoBar/updateCTALinkId');
export const promoBarUpdateCTABlockId = createAction('promoBar/updateCTABlockId');
export const promoBarUpdateCTAOpacity = createAction('promoBar/updateCTAOpacity');
export const promoBarUpdateCTATextColor = createAction('promoBar/updateCTATextColor');
export const promoBarUpdateCTABackgroundColor = createAction('promoBar/updateCTABackgroundColor');
export const promoBarUpdateCTABackgroundColorRGBA = createAction('promoBar/updateCTABackgroundColorRGBA');
export const promoBarUpdateCTABorder = createAction('promoBar/updateCTABorder');
export const promoBarUpdateCTABorderColor = createAction('promoBar/updateCTABorderColor');
export const promoBarUpdateCTAShadow = createAction('promoBar/updateCTAShadow');
export const promoBarUpdateCTAShadowColor = createAction('promoBar/updateCTAShadowColor');
export const promoBarUpdateCTAShape = createAction('promoBar/updateCTAShape');
